import React from 'react';
import styled from 'styled-components';
import { formatNumber } from 'utils/formatCurrency';
import StatisticCustomerItem from './StatisticCustomerItem';
import Icon from 'assets/Icons';
import { formatCurrency } from 'utils/formatCurrency';
import customerSelectors from 'features/customer/services/selectors';
import { Tabs } from 'antd';
import { TabsProps } from 'antd/lib';
import AppointmentTab from 'features/customer/pages/CustomerDetails/components/tabs/AppointmentTab';
import CouponActiveTab from 'features/customer/pages/CustomerDetails/components/tabs/CouponActiveTab';
import TransactionsTab from 'features/customer/pages/CustomerDetails/components/tabs/TransactionsTab';
import ReferralTab from 'features/customer/pages/CustomerDetails/components/tabs/ReferralTab';
import CouponTab from 'features/customer/pages/CustomerDetails/components/tabs/CouponTab';

const RightCustomerDetailsContent = () => {
  const summaryReportData = customerSelectors.summaryReportData.data();

  const items: TabsProps['items'] = [
    {
      key: 'transactions',
      label: 'Transactions',
      children: <TransactionsTab />,
    },
    {
      key: 'appointment',
      label: 'Appointment',
      children: <AppointmentTab />,
    },
    {
      key: 'referral',
      label: 'Referral',
      children: <ReferralTab />,
    },
    {
      key: 'coupon-active',
      label: 'Coupon Active',
      children: <CouponActiveTab />,
    },
    {
      key: 'coupon',
      label: 'Coupon Redeem',
      children: <CouponTab />,
    },
  ];

  return (
    <ContainerStyled>
      <RightContentStyled>
        <StatisticContainer>
          <StatisticCustomerItem
            label='spent'
            value={formatCurrency(summaryReportData?.amountSpend)}
            icon={<Icon type='IcGiftBox' />}
          />
          <StatisticCustomerItem
            label='point'
            value={formatNumber(summaryReportData?.point)}
            icon={<Icon type='IcPoint' />}
          />
          <StatisticCustomerItem
            label='appT'
            value={formatNumber(summaryReportData?.totalAppointment)}
            icon={<Icon type='IcApt' />}
          />
          <StatisticCustomerItem
            label='Referral'
            value={formatNumber(summaryReportData?.totalUsedCoupon)}
            icon={<Icon type='IcApt' />}
          />
        </StatisticContainer>
      </RightContentStyled>
      <Tabs items={items} defaultActiveKey='appointment' />
    </ContainerStyled>
  );
};

export default RightCustomerDetailsContent;

const ContainerStyled = styled.div`
  flex: 1;
  border-radius: 8px;
  background: #f6f7fc;
  padding: 16px 24px 0px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow: auto;

  .ant-tabs .ant-tabs-tab {
    padding: 22px 16px;
    padding-top: 32px;
    margin: 0;
  }
  .ant-tabs .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-ink-bar {
    height: 3px;
    background: #2d6772;
  }
  .ant-tabs .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab {
    .ant-tabs-tab-btn {
      color: #64748b;
      text-align: center;
      font-family: Poppins;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    &.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: #2d6772;
      font-weight: 600;
    }
  }

  .ant-tabs-content-holder .ant-tabs-content .ant-tabs-tabpane {
    .ant-table-wrapper .ant-table .ant-table-content {
      .ant-table-thead th.ant-table-cell,
      .ant-table-thead td.ant-table-cell {
        height: 48px;
        padding: 0px 8px;
        gap: 10px;
        align-self: stretch;
        border-bottom: 1px solid #ccd4dc;
        background: #6fabb6;
        color: #1d2129;
        font-family: Poppins;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-transform: capitalize;
        text-align: left !important;
        &::before {
          width: 1.5px;
          height: 100%;
        }
      }

      .ant-table-tbody td.ant-table-cell {
        .BODY_1,
        .CONTENT_2 {
          color: #1d2129;
          font-family: Poppins;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
      }

      .ant-table-tbody .ant-table-row:nth-child(even) td {
        background: #e4f4f6;
        border-bottom: 1px solid #e4f4f6;
      }
    }
  }
`;

const RightContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  border-radius: 8px;
  background: #f6f7fc;
`;

const StatisticContainer = styled.div`
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: #f5f5f5;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
`;
